import React from "react";
import CommonLayout from "../../components/Layouts/CommonLayout";
import Transaction from "../../components/TransactionSuccess";

const TransactionSuccessPage = () => {
  return <Transaction />;
};

export default TransactionSuccessPage;
